// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"92d9083a827a07d2","3185":"de6b29eb3bda4d74","5444":"b39dbd97004bc4b5"}[chunkId] + ".css";
};